var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrashCircle = function SvgTrashCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "#FFE3D6",
    rx: 48
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3236",
    d: "M45 34h6a1 1 0 0 1 1 1v2h-8v-2a1 1 0 0 1 1-1m9 3v-2a3 3 0 0 0-3-3h-6a3 3 0 0 0-3 3v2h-7a1 1 0 1 0 0 2h1.077l1.705 21.319A4 4 0 0 0 41.77 64h12.46a4 4 0 0 0 3.988-3.681L59.923 39H61a1 1 0 1 0 0-2h-7m3.917 2-1.693 21.16A2 2 0 0 1 54.23 62H41.77a2 2 0 0 1-1.994-1.84L38.083 39zM42.94 41.002a1 1 0 0 1 1.057.94l1 17a1 1 0 0 1-1.996.117l-1-17a1 1 0 0 1 .94-1.057m10.118 0a1 1 0 0 1 .94 1.057l-1 17a1 1 0 0 1-1.997-.118l1-17a1 1 0 0 1 1.057-.94M48 41a1 1 0 0 1 1 1v17a1 1 0 1 1-2 0V42a1 1 0 0 1 1-1"
  })));
};
export default SvgTrashCircle;